module.exports = __webpack_public_path__ + "static/media/settings-min-min.2594a38d.png";